import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { AggridDiv, AggridInsertButton, AggridRemoveButton } from "src/components/common/common";
import { GridSettingContentProps, useGridSettingContent } from "src/utils/grid/GridSettingContent";

const IndexCellRenderer = forwardRef((initialParams: any, ref: React.ForwardedRef<any>) => {
	const [params, setParams] = useState(initialParams);

	// AG Grid가 리마운트 대신 이 메서드를 호출해 params를 갱신
	useImperativeHandle(ref, () => ({
		refresh: (newParams: any) => {
			setParams(newParams);
			return true;
		}
	}), []);

	if (params.node?.rowPinned === 'bottom') return <></>;

	const { getRowStyleFlagsCallback, handleInsertCallback, handleRemoveCallback } = params;
	const { isDeleted, isModified, isInserted } = getRowStyleFlagsCallback(params);

	return (
		<div
			style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}
		>
			<AggridDiv className="ag-row-cell-with-buttons">
				{/* <span className="ag-row-normal-cell" style={{ fontSize: '16px', textAlign: 'center', width: '100%' }}>
					{rowIndexContent}
				</span> */}
				<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', width: '100%' }}>
					<AggridInsertButton handleInsertClick={(e) => handleInsertCallback(params.node.rowIndex, e)} />
					<AggridRemoveButton handleRemoveClick={() => handleRemoveCallback(params.data)} />
				</span>
			</AggridDiv>
		</div>
	);
});

IndexCellRenderer.displayName = 'KSK2120_R01IndexCellRenderer';

export const useKSK2120_R01GridSettingContent = <TData extends Record<string, any> = any>(
	props: GridSettingContentProps<TData>
) => {
	const base = useGridSettingContent(props);

	return {
		...base,
		IndexCellRenderer,
	};
};
